import * as React from 'react';
import { useDispatch } from 'react-redux';

import { loadUnreadMessages } from '../../actions/messages';
import { TThunkDispatch } from '../../types/redux';

export const UnreadMessagesLoader: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  React.useEffect(() => {
    dispatch(loadUnreadMessages());
  }, [dispatch]);

  return null;
};
